import Draggable from 'vuedraggable';

export default {
  install(Vue) {
    Vue.component('Draggable', Draggable);
  },
};
